import { render, staticRenderFns } from "./zhujing.vue?vue&type=template&id=7d829356&scoped=true"
import script from "./zhujing.vue?vue&type=script&lang=js"
export * from "./zhujing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d829356",
  null
  
)

export default component.exports